import {
  formatDateWithTime,
  gridSizeConst1,
  gridSizeConst10,
  gridSizeConst2,
  gridSizeMdLg12,
  gridSizeMdLg5,
  gridSizeMdLg6,
  handleAxiosError,
  texto,
  TipoIdentificacionEnumChoice,
} from "@/shared";
import SearchIcon from "@mui/icons-material/Search";
import {
  CustomAutocomplete,
  CustomAutocompleteArrString,
  CustomTextFieldNumberComponente,
} from "@/shared/components/ui";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import {
  CondicionVentaCorporativaOptions,
  //   IProspectoCorporativo,
  ISolicitudCanje,
  ISolicitudEvento,
  RangoEdadEnum,
  TipoSolicitudesEnum,
} from "@/shared/interfaces";
import { Grid, IconButton, Tooltip } from "@mui/material";
// import { UseFormReturn } from "react-hook-form";
import { Visibility } from "@mui/icons-material";
import ModalSolicitudCanje from "@/erp/marketing/revision-evento-canje/shared/ModalSolicitudesEventoCanje/ModalSolicitudCanje";
import ModalSolicitudEvento from "@/erp/marketing/revision-evento-canje/shared/ModalSolicitudesEventoCanje/ModalSolicitudEvento";
import { useState } from "react";
import { useUiStore } from "@/store/ui";
import { getSolicitudCanje } from "@/shared/actions/erp/marketing";
import { getSolicitudEvento } from "@/shared/actions/erp/marketing/solicitudEvento.action";

interface CondicionVentaPymesProps {
  /**
   * Formulario que contenga obligatoriamente los campos:
   * - condicion_venta:string
   * - identificacion_canje_evento:string
   * - solicitud_canje:string
   * - solicitud_evento:string
   * - requiere_inspeccion:boolean
   * - requiere_cotizacion:boolean
   * - solicitud_canje_data:IsolicitudCanje
   * - solicitud_evento_data:IsolicitudEvento
   */
  form: any;
  servicio?: string | null
  //handleDataSolicitud: (aux: ISolicitudEvento | ISolicitudCanje) => void
  handleDataSolicitud: (aux: any) => void
}


export default function CondicionVentaPymes({
  form,
  servicio = null,
  handleDataSolicitud,
}: CondicionVentaPymesProps) {
  // =========================================================================
  // states
  // =========================================================================
  const [openPreviewSolicitud, setOpenPreviewSolicitud] = useState<boolean>(false);
  const [dataCanje, setDataCanje] = useState<ISolicitudCanje[]>([]);
  const [dataEvento, setDataEvento] = useState<ISolicitudEvento[]>([]);
  // ===========================================================================
  // Stored functions
  // ===========================================================================
  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);

  // =========================================================================
  // form
  // =========================================================================
  const {
    reset,
    control,
    formState: { errors },
  } = form;
  // =========================================================================
  // Handlers and functions
  // =========================================================================
  ///* buscar canje por cedula
  const handleBuscarCanje = async (identificacion: string) => {
    try {
      setIsGlobalLoading(true);
      const resp = await getSolicitudCanje({
        identificacion: identificacion,
        servicio,
        page_size: 600,
        estado: true
      });

      const dataCanje: ISolicitudCanje[] = resp.data.data.map((e) => {
        return {
          ...e,
          razon_social: `${e.razon_social} - ${formatDateWithTime(
            e.fecha_creacion
          )}`,
        };
      });

      setDataCanje(dataCanje ?? []);
    } catch (error) {
      handleAxiosError(error);
    } finally {
      setIsGlobalLoading(false);
    }
  };

  const handleBuscarEvento = async (identificacion: string) => {
    try {
      setIsGlobalLoading(true);
      const resp = await getSolicitudEvento({
        identificacion: identificacion,
        servicio,
        page_size: 600,
        estado: true
      });

      const dataEvento: ISolicitudEvento[] = resp.data.data.map((e) => {
        return {
          ...e,
          nombre: `${e.nombre} - ${formatDateWithTime(e.fecha_creacion)}`,
        };
      });

      setDataEvento(dataEvento ?? []);
    } catch (error) {
      handleAxiosError(error);
    } finally {
      setIsGlobalLoading(false);
    }
  };

  const handleBuscarSolicitudCanje = (aux: string) => {
    // Verifica la longitud de la cadena
    if (aux.length === 10 || aux.length === 13) {
      const { condicion_venta } = form.getValues()

      switch (condicion_venta) {
        case TipoSolicitudesEnum.CANJE:
          handleBuscarCanje(aux);
          break;
        case TipoSolicitudesEnum.EVENTO_GRATUITO:
        case TipoSolicitudesEnum.EVENTO_PAGADO:
          handleBuscarEvento(aux);
          break;
        default:
          break;
      }
      return;
    }

    // Si la longitud no es válida, se limpian los datos
    setDataCanje([]);
    setDataEvento([]);
  };

  const handleBuscarIconSolicitudCanje = (
    e: React.FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();

    const { identificacion_canje_evento: identificacion, condicion_venta } =
      form.getValues();

    if (!identificacion) return;
    if (identificacion.length !== 10 && identificacion.length !== 13) return;

    switch (condicion_venta) {
      case TipoSolicitudesEnum.CANJE:
        handleBuscarCanje(identificacion);
        break;
      case TipoSolicitudesEnum.EVENTO_GRATUITO:
      case TipoSolicitudesEnum.EVENTO_PAGADO:
        handleBuscarEvento(identificacion);
        break;
      default:
        break;
    }
  };

  const handleLimpiarSolicitudCanjeEvento = () => {
    reset({
      ...form.getValues(),
      identificacion_canje_evento: "",
      solicitud_canje: "",
      solicitud_evento: "",
    });

    setDataCanje([]);
    setDataEvento([]);
  };

  return (
    <Grid container spacing={3} {...gridSizeMdLg12}>

      <CustomAutocompleteArrString
        size={gridSizeMdLg6}
        label={"Condición Venta"}
        name="condicion_venta"
        options={CondicionVentaCorporativaOptions}
        defaultValue={form.getValues().condicion_venta || ""}
        isLoadingData={false}
        required={false}
        control={form.control}
        error={errors.condicion_venta}
        helperText={errors.condicion_venta?.message}
        onChangeValue={() => {
          handleLimpiarSolicitudCanjeEvento();
          //handleSelectCondicion && handleSelectCondicion();
          reset({
            ...form.getValues(),
            tipo_servicio: "",
            plan: "",
            promocion: "",
            velocidad: "",
            valor_plan: "",
            numero_cuotas_router_ac: 0,
            numero_cantidad_router_ac: 0,
            es_pago_total: false,
          });

          /* if (val == null) {
            reset({
              ...form.getValues(),
              requiere_inspeccion: false,
              requiere_cotizacion: false,
            });
          } */
        }}
      />

      {form.getValues().condicion_venta && (
        <>
          <Grid
            container
            spacing={1}
            item
            xs={6}
            style={{
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <CustomTextFieldNumberComponente
              size={gridSizeConst10}
              max={13}
              type={TiposTextFieldNumberEnum.IDENTIFICACION}
              label={texto.identificacion_condicion_venta}
              error={errors.identificacion_canje_evento}
              helperText={errors.identificacion_canje_evento?.message}
              control={control}
              name="identificacion_canje_evento"
              defaultValue={form.getValues().identificacion_canje_evento || ""}
              onChangeValue={(aux) => {
                handleBuscarSolicitudCanje(aux);
              }}
            />

            <Grid item {...gridSizeConst2}>
              <IconButton
                onClick={(e: any) => {
                  handleBuscarIconSolicitudCanje(e);
                }}
                size="small"
              >
                <SearchIcon />
              </IconButton>
            </Grid>
          </Grid>

          {form.getValues().condicion_venta == TipoSolicitudesEnum.CANJE && (
            <CustomAutocomplete<ISolicitudCanje>
              size={gridSizeMdLg5}
              label="Seleccionar Canje"
              name="solicitud_canje"
              options={
                dataCanje?.filter((x) => x.canje_aplicado == false) || []
              }
              valueKey="razon_social"
              actualValueKey="codigo"
              defaultValue={undefined}
              isLoadingData={false}
              control={control}
              error={errors.solicitud_canje}
              onChangeRawValue={(rawValue) => {
                reset({
                  ...form.getValues(),
                  edad: RangoEdadEnum.EDAD_MINIMA, // TODO: Edad para prospecto hogar
                  tipo_identificacion: TipoIdentificacionEnumChoice.RUC, // TODO: Todo canje/evento solo se puede hacer por RUC
                  solicitud_canje_data: rawValue,
                  identificacion: rawValue?.identificacion,
                  celular: rawValue?.numero_contacto,
                  direccion: rawValue?.direccion,
                  persona_contacto: rawValue?.nombre_contacto,
                  coordenadas: rawValue.coordenadas
                })

                handleDataSolicitud(rawValue);
              }

              }
              helperText={errors.solicitud_canje?.message}
            />
          )}

          {(form.getValues().condicion_venta ==
            TipoSolicitudesEnum.EVENTO_GRATUITO ||
            form.getValues().condicion_venta ==
            TipoSolicitudesEnum.EVENTO_PAGADO) && (
              <CustomAutocomplete<ISolicitudEvento>
                size={gridSizeMdLg5}
                label="Seleccionar Evento"
                name="solicitud_evento"
                options={
                  dataEvento?.filter((x) => x.evento_aplicado == false) || []
                }
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={undefined}
                isLoadingData={false}
                control={control}
                error={errors.solicitud_evento}
                onChangeRawValue={(rawValue) => {
                  reset({
                    ...form.getValues(),
                    edad: RangoEdadEnum.EDAD_MINIMA, // TODO: Edad para prospecto hogar
                    tipo_identificacion: TipoIdentificacionEnumChoice.RUC, // TODO: Todo canje/evento solo se puede hacer por RUC
                    solicitud_evento_data: rawValue,
                    identificacion: rawValue?.identificacion,
                    celular: rawValue?.numero_contacto,
                    persona_contacto: rawValue?.nombre_contacto,
                    coordenadas: rawValue.coordenadas,
                  });

                  handleDataSolicitud(rawValue);
                }
                }
                helperText={errors.solicitud_evento?.message}
              />
            )}

          <Grid {...gridSizeConst1} item alignContent={"center"}>
            {!!form.getValues()?.solicitud_evento_data ||
              !!form.getValues()?.solicitud_canje_data ? (
              <Tooltip title="Vista previa de Solicitud">
                <IconButton onClick={() => setOpenPreviewSolicitud(true)}>
                  <Visibility />
                </IconButton>
              </Tooltip>
            ) : null}
          </Grid>

          {form.getValues()?.condicion_venta == TipoSolicitudesEnum.CANJE ? (
            <ModalSolicitudCanje
              showModal={openPreviewSolicitud}
              setShowModal={setOpenPreviewSolicitud}
              dataSelected={form.getValues()?.solicitud_canje_data!}
            />
          ) : null}
          {form.getValues()?.condicion_venta ==
            TipoSolicitudesEnum.EVENTO_GRATUITO ||
            form.getValues()?.condicion_venta ==
            TipoSolicitudesEnum.EVENTO_PAGADO ? (
            <ModalSolicitudEvento
              showModal={openPreviewSolicitud}
              setShowModal={setOpenPreviewSolicitud}
              dataSelected={form.getValues()?.solicitud_evento_data!}
            />
          ) : null}
        </>
      )}
    </Grid>
  );
}
